import { Link } from 'react-router-dom';
import { Icon } from '@/components/Icons';

export default function NotFoundScreen() {
    return (
        <div className="screen-wrapper fade-in" style={{ justifyContent: 'center', textAlign: 'center' }}>
            <Icon name="alertTriangle" size={48} color="var(--warning)" />
            <h1 style={{ fontSize: 32, fontWeight: 700 }}>404</h1>
            <p style={{ color: 'var(--ink-500)' }}>Halaman tidak ditemukan.</p>
            <Link to="/onboarding/welcome" className="btn btn-primary" style={{ alignSelf: 'center' }}>
                Kembali ke Beranda
            </Link>
        </div>
    );
}
